<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">Trinka 技術平台專用方案</h1>
                        <h2>將寫作輔助功能整合進您的應用程式</h2>
                        <p>Trinka AI 讓您輕鬆在應用程式中加入即時寫作輔助，為使用者提供精準的語言建議，打造獨一無二的解決方案與使用體驗。</p>
                        <div class="btn-group">
                            <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">索取報價 </button>
                            <a href="https://calendly.com/trinkaai/meet" target="_blank" id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/enterprise/technologyPlatform.webp" width="500" height="400" alt="Trinka enterprise" class="img-fluid md50" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd trinka-key-features">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>專為不同平台打造的整合方案</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="gt-features three-coloum">
                    <span class="hr-line"></span>
                    <span class="vr-line l25"></span>
                    <span class="vr-line l50"></span>
                    <span class="vr-line l75"></span>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>內容管理系統（CMS）</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>線上寫作平台</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>即時通訊與社群媒體平台</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>客戶關係與客服系統（CRM／Helpdesk）</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>電子郵件服務平台</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>專案管理工具</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>線上教學平台</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>學習管理系統</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>創造差異化產品體驗的獨特功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>
                        全面啟用 Trinka 的強大功能，提升產品價值與使用者體驗。從高級文法校正到語氣與風格的優化，Trinka 提供全方位的寫作輔助，助您打造更出色的內容與互動體驗。
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                    <div class="features_cards_icon">
                        <img src="/assets/images/Real-timewritingsuggestions.png" width="40" height="40" alt="real time writing" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>進階即時寫作輔助，內建於您的應用程式中</h3>
                        <p>Trinka AI 可即時偵測並修正複雜的文法錯誤，直接在您的應用程式內提供服務。除了文法檢查外，Trinka 還能優化詞彙、語氣、句構、用字與語句表達，全面提升寫作品質。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title">
                    <div class="features_cards_icon">
                        <img src="/assets/images/Qualityassessment.png" width="40" height="40" alt="quality assessment" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>
                            自訂評分與個人詞典
                        </h3>
                        <p>透過可自訂的評分演算法，為使用者的寫作進行量化評估，同時支援個人化詞典設定，打造專屬寫作輔助體驗。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/WhiteLabel.png" width="40" height="40" alt="white label" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>白標整合</h3>
                        <p>Trinka 提供完整的白標整合方案，可無縫嵌入您的產品中，讓您延續自有品牌識別與信任標誌，打造專屬且高辨識度的 AI 解決方案。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/DedicatedSupport.svg" width="40" height="40" alt="dedicated supported" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>專屬服務支援</h3>
                        <p>專屬客戶經理將協助您的團隊充分發揮 Trinka 的效益，服務內容包括詳細的入門說明電話、協助文件以及操作影片導覽。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="border-top">
    <app-iplisting></app-iplisting>
</section>

<section class="list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="trinka-title mb-0 text-center">
                                <h2>多元彈性整合，滿足各種應用情境</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>善用 Trinka 的各項功能，打造驅動成長的產品與服務</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-none">
                                <h3>
                                    即時寫作輔助
                                </h3>
                                <p>讓您的使用者能在應用程式中即時獲得寫作建議，提升寫作效率與表現。</p>
                                <ul>
                                    <li>超過 3,000 項文法檢查</li>
                                    <li>詳細錯誤說明</li>
                                    <li>支援自訂修正內容</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>寫作品質評估</h3>
                                <p>Trinka AI 提供可自訂的寫作評分與錯誤分析，助力學習管理系統（LMS）、線上學習平台等打造客製化學習體驗。</p>
                                <ul>
                                    <li>寫作品質分數</li>
                                    <li>錯誤類別報告</li>
                                    <li>互動式修正建議與解釋
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>即用型個人化功能</h3>
                                <p>Trinka 支援使用者字典、自訂修正與風格指南，以及自訂個人後台，協助您打造個人化使用體驗。</p>
                                <ul>
                                    <li>使用者可建立個人詞典</li>
                                    <li>新增符合品牌或應用風格的修訂指南</li>
                                    <li>透過強大的數據收集與監測功能取得精準洞察</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-grammar-without-internet [windowsButton]="false"></app-grammar-without-internet>

<section class="cloud_key_features section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>與您專屬軟體及工作流程無縫整合</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 提供簡單的整合方案，讓您的團隊能直接在現有軟體中使用，讓寫作更有效率、流程更順暢。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>JavaScript 整合</h3>

                    <p>
                        只需在瀏覽器或任意應用程式中插入一段簡短的 JavaScript（JS）程式碼，即可為所有團隊成員啟用 Trinka。
                    </p>

                    <a [routerLink]="['/enterprise']" class="text-link">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>API 整合</h3>
                    <p>
                        Trinka 強大的 API 可無縫嵌入您現有的應用程式，透過簡潔的架構設計，讓整合變得輕鬆又快速。
                    </p>

                    <a [routerLink]="['/enterprise/grammar-checker-api']" class="text-link">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>內部部署</h3>
                    <p>
                        將 Trinka 部署於您企業的本地或雲端伺服器，確保寫作效率同時達到最高等級的資料保密與控管。
                    </p>

                    <a [routerLink]="['/enterprise/']" class="text-link">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<app-personal-pricing></app-personal-pricing>

<app-local-invoice></app-local-invoice>

<app-about-trinka></app-about-trinka>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">讓您寫作更出色</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn nowrap" type="button">索取報價</button>
                </div>
            </div>
        </div>
    </div>
</div>